import axios from './APIClient';
// import {CancelToken,isCansel} from 'axios'

export const uploadService = (
  file,
  link,
  onUploadProgress,
  source = { token: null },
) => {
  let formData = new FormData();
  formData.append('file', file);

  return axios.post(link, formData, {
    timeout: 1800000,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
    cancelToken: source.token,
  });
};

// export const uploadServiceContent = (
//   content,
//   link,
//   onUploadProgress,
//   source = { token: null },
// ) => {
//   return axios.post(link, content, {
//     timeout: 500000,
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//     onUploadProgress,
//     cancelToken: source.token,
//   });
// };
export const uploadServiceContent = (
  content,
  link,
) => {
  return axios.post(link, content, {
    timeout: 1800000,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
